// src/pages/ForgotPasswordRequest.jsx
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { API_BASE_URL } from '../infra/apiConfig';
import { Link } from 'react-router-dom';

export default function ForgotPasswordRequest() {
  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm();
  const [loadingMessage, setLoadingMessage] = useState("");

  const onSubmit = async (data) => {
  try {
    setLoadingMessage("Enviando e-mail de recuperação...");

    const response = await axios.post(`${API_BASE_URL}/recuperar-senha`, { email: data.email });

    setLoadingMessage("");
    alert(response.data.message || "Se o e-mail estiver cadastrado, você receberá instruções para redefinir sua senha.");
  } catch (err) {
    setLoadingMessage("");

    // 🔍 Mostra tudo no console
    console.group("Erro na recuperação de senha");
    if (err.response) {
      console.error("Status:", err.response.status);
      console.error("Dados retornados:", err.response.data);
    } else if (err.request) {
      console.error("Nenhuma resposta recebida:", err.request);
    } else {
      console.error("Erro ao configurar requisição:", err.message);
    }
    console.groupEnd();

    alert("Erro ao processar pedido. Verifique o console para mais detalhes.");
  }
};


  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-blue-100 p-4">
      <div className="w-full max-w-md p-8 bg-white rounded-2xl shadow">
        <h2 className="text-2xl font-bold mb-2">Recuperar senha</h2>
        <p className="mb-4 text-sm text-gray-600">
          Informe o e-mail cadastrado. Enviaremos um link para você criar uma nova senha.
        </p>

        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">E-mail</label>
            <input
              type="email"
              className={`mt-1 w-full p-2 border ${errors.email ? 'border-red-500' : 'border-gray-300'} rounded-md`}
              {...register('email', {
                required: 'O e-mail é obrigatório',
                pattern: { value: /^\S+@\S+$/i, message: 'E-mail inválido' }
              })}
              disabled={isSubmitting}
            />
            {errors.email && <p className="text-sm text-red-600">{errors.email.message}</p>}
          </div>

          <button
            type="submit"
            disabled={isSubmitting}
            className={`w-full py-2 text-white rounded-md transition ${
              isSubmitting
                ? 'bg-blue-400 cursor-not-allowed'
                : 'bg-blue-600 hover:bg-blue-700'
            }`}
          >
            {isSubmitting ? 'Enviando...' : 'Enviar instruções'}
          </button>
        </form>

        {loadingMessage && (
          <p className="mt-4 text-center text-sm text-gray-600 animate-pulse">
            {loadingMessage}
          </p>
        )}

        <div className="mt-4 text-sm text-center">
          <Link to="/" className="text-blue-600 hover:text-blue-500">Voltar ao login</Link>
        </div>
      </div>
    </div>
  );
}
